// @ts-nocheck
import { attendCode, cardDeviceTypeCode, employeeTypeCode, salaryTypeCode, workerStatusCode, workerTypeCode, } from '@/constants';
import { injectSeparatorDateString, injectSeparatorTimeString, currency, formatBankAccount, socialNumberMasking, calculateAgeFromSocialNumber, validateTextWithHypen, } from '@/utils';
import { formatPhoneNumber } from '@/utils/regularExpression';
export default class MobileWorkerDetail {
    _name;
    _code;
    _nowAllocatedCount;
    _nowPickupCount;
    _telNumber;
    _workerRegDate;
    _workerLeaveDate;
    _depositBaromoney;
    _memo;
    _distributorDTO;
    _hubDTO;
    phone;
    _workTime;
    _statusCode;
    _attendCode = null;
    _employeeType;
    _salaryType;
    _type;
    _cardDeviceType;
    _baromoney;
    _virtualBankAccount;
    _withdrawalBankCode;
    _withdrawalBankOwner;
    _withdrawalBankAccount;
    option;
    _orderDelayTimeSecond;
    _acceptedOrderViewLimitCount;
    _maxAllocateCount;
    _minFinishMinuteAfterAllocated;
    _socialNumber;
    _carNumber;
    _licenseNumber;
    constructor({ statusCode: _statusCode, name: _name, code: _code, nowAllocatedCount: _nowAllocatedCount, nowPickupCount: _nowPickupCount, telNumber: _telNumber, workerRegDate: _workerRegDate, workerLeaveDate: _workerLeaveDate, depositBaromoney: _depositBaromoney, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    memo: _memo, distributorDTO: _distributorDTO, hubDTO: _hubDTO, workTime: _workTime, attendCode: _attendCode, employeeType: _employeeType, type: _type, salaryType: _salaryType, cardDeviceType: _cardDeviceType, orderDelayTimeSecond: _orderDelayTimeSecond, acceptedOrderViewLimitCount: _acceptedOrderViewLimitCount, maxAllocateCount: _maxAllocateCount, minFinishMinuteAfterAllocated: _minFinishMinuteAfterAllocated, baromoney: _baromoney, withdrawalBankCode: _withdrawalBankCode, virtualBankAccount: _virtualBankAccount, withdrawalBankOwner: _withdrawalBankOwner, withdrawalBankAccount: _withdrawalBankAccount, socialNumber: _socialNumber, age: _age, carNumber: _carNumber, licenseNumber: _licenseNumber, ..._worker }) {
        Object.assign(this, {
            ..._worker,
            _statusCode,
            _name,
            _code,
            _telNumber,
            _workerRegDate,
            _workerLeaveDate,
            _depositBaromoney,
            _distributorDTO,
            _hubDTO,
            _workTime,
            _attendCode,
            _nowAllocatedCount,
            _nowPickupCount,
            _employeeType,
            _type,
            _salaryType,
            _cardDeviceType,
            _orderDelayTimeSecond,
            _acceptedOrderViewLimitCount,
            _maxAllocateCount,
            _minFinishMinuteAfterAllocated,
            _baromoney,
            _withdrawalBankCode,
            _withdrawalBankAccount,
            _withdrawalBankOwner,
            _virtualBankAccount,
            _socialNumber,
            _age,
            _carNumber,
            _licenseNumber,
        });
    }
    get status() {
        if (attendCode.WAITING.code === this.attendCode) {
            return {
                type: attendCode.WAITING.type,
                value: attendCode.WAITING.text,
                color: '#0096FF',
            };
        }
        if ([
            attendCode.ALLOCATED.code,
            attendCode.DRIVING.code,
            '',
        ].includes(this.attendCode)) {
            return {
                type: attendCode.DRIVING.type,
                value: attendCode.DRIVING.text,
                color: '#E57373',
            };
        }
        return {
            type: attendCode.REST.type,
            value: attendCode.REST.text,
            color: '#9E9E9E',
        };
    }
    get workerName() {
        return `${this._name} 라이더`;
    }
    get fulfillmentInfo() {
        return `배 ${this._nowAllocatedCount} | 픽 ${this._nowPickupCount}`;
    }
    // currentWorkerPositionAddress() {
    //   return '현재 위치 주소(동까지 표기)';
    // }
    // distanceFromStore() {
    //   return '상점과의 거리 1.4km';
    // }
    get name() {
        return this._name;
    }
    get code() {
        return this._code;
    }
    get emergencyContact() {
        return formatPhoneNumber(this._telNumber);
    }
    get workerRegDate() {
        return injectSeparatorDateString(this._workerRegDate);
    }
    get workerLeaveDate() {
        return injectSeparatorDateString(this._workerLeaveDate);
    }
    get depositBaromoney() {
        return currency(this._depositBaromoney);
    }
    get memo() {
        return validateTextWithHypen(this._memo);
    }
    get hubName() {
        return validateTextWithHypen(this._hubDTO?.name);
    }
    get workerPhone() {
        return formatPhoneNumber(this.phone);
    }
    get workTime() {
        return injectSeparatorTimeString(this._workTime);
    }
    get workerStatusCode() {
        return workerStatusCode[this._statusCode]?.text ?? '';
    }
    get attendCode() {
        return attendCode[this._attendCode]?.code ?? '';
    }
    get attendCodeText() {
        return attendCode[this._attendCode]?.text ?? '';
    }
    get nowAllocatedCount() {
        return this._nowAllocatedCount;
    }
    get nowPickupCount() {
        return this._nowPickupCount;
    }
    get employeeType() {
        return employeeTypeCode[this._employeeType];
    }
    get salaryType() {
        return salaryTypeCode[this._salaryType];
    }
    get workerType() {
        return workerTypeCode[this._type]?.text ?? '';
    }
    get cardDeviceType() {
        return cardDeviceTypeCode[this._cardDeviceType]?.usage ?? '';
    }
    get baromoney() {
        return currency(this._baromoney);
    }
    get virtualBankAccount() {
        return formatBankAccount(this._virtualBankAccount);
    }
    get bankName() {
        return this._withdrawalBankCode;
    }
    get withdrawalBankAccountOwner() {
        return validateTextWithHypen(this._withdrawalBankOwner);
    }
    get withdrawalBankAccount() {
        return validateTextWithHypen(formatBankAccount(this._withdrawalBankAccount));
    }
    get needGPSOn() {
        return this.option.substring(6, 7) === 'Y'
            ? 'views.worker.worker_detail.need_gps_activate_on'
            : 'views.worker.worker_detail.need_gps_activate_off';
    }
    get orderDelayTime() {
        return {
            message: i18n.t('views.worker.worker_detail.order_delay_time_second'),
            context: {
                seconds: this._orderDelayTimeSecond,
            },
        };
    }
    get acceptedOrderViewLimitCount() {
        return {
            message: i18n.t('views.worker.worker_detail.accepted_order_view_limit_count'),
            context: {
                count: this._acceptedOrderViewLimitCount,
            },
        };
    }
    get sharedOn() {
        return this.option.substring(4, 5) === 'Y'
            ? 'views.worker.worker_detail.shared_order_on'
            : 'views.worker.worker_detail.shared_order_off';
    }
    get maxAllocateCount() {
        return {
            message: i18n.t('views.worker.worker_detail.max_allocate_count_count'),
            context: {
                count: this._maxAllocateCount,
            },
        };
    }
    get minFinishMinuteAfterAllocated() {
        return {
            message: i18n.t('views.worker.worker_detail.min_finish_minute_after_allocated_minute'),
            context: {
                count: this._minFinishMinuteAfterAllocated,
            },
        };
    }
    get availableCancelAllocated() {
        return this.option.substring(5, 6) === 'Y'
            ? 'views.worker.worker_detail.available_cancel_allocated_on'
            : 'views.worker.worker_detail.available_cancel_allocated_off';
    }
    get availableChangePickupExpectedAt() {
        return this.option.substring(8, 9) === 'Y'
            ? 'views.worker.worker_detail.available_change_pickup_expected_at_on'
            : 'views.worker.worker_detail.available_change_pickup_expected_at_off';
    }
    get availableChangeDropAddress() {
        return this.option.substring(1, 2) === 'Y'
            ? 'views.worker.worker_detail.available_change_drop_address_on'
            : 'views.worker.worker_detail.available_change_drop_address_off';
    }
    get availableChangePayment() {
        return this.option.substring(0, 1) === 'Y'
            ? 'views.worker.worker_detail.available_change_payment_on'
            : 'views.worker.worker_detail.available_change_payment_off';
    }
    get socialNumber() {
        return socialNumberMasking(this._socialNumber);
    }
    get age() {
        return calculateAgeFromSocialNumber(this._socialNumber);
    }
    get carNumber() {
        return validateTextWithHypen(this._carNumber);
    }
    get licenseNumber() {
        return validateTextWithHypen(this._licenseNumber);
    }
    get distributorDTO() {
        return this._distributorDTO;
    }
    get hubDTO() {
        return this._hubDTO;
    }
    distributorName() {
        return this._distributorDTO?.name;
    }
}
